export const locationCategories = [
  'Southeast Asia',
  'Central America',
  'Balkans',
  'Europe',
  'Central Asia',
  'South America',
  'Eastern Europe',
  'Africa',
  'Asia',
  'Oceania',
  'Americas',
  'Western Europe',
  'Eastern Asia',
  'Middle East',
  'North America',
  'Northern Europe',
  'Southern Europe',
  'Caucasus',
  'Baltics',
  'Latin America',
  'Caribbean',
  'Northern Africa',
  'Southern Asia',
  // 'Sub-Saharan Africa',
  // 'Melanesia',
  // 'Middle Africa',
  // 'Australia and New Zealand',
  // 'Southern Africa',
  // 'Eastern Africa',
  // 'Western Africa',
];
